// export const BASE_URL = "http://localhost:5000";
export const BASE_URL = "https://swift-indexer-backend.thecreatorpreneur.in";
// export const CanonicalURL = "http://localhost:3000";
export const CanonicalURL = "https://swift-indexer.thecreatorpreneur.in/";
